"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonType = void 0;
var PersonType;
(function (PersonType) {
    PersonType["PARTICIPANT"] = "participant";
    PersonType["PAYER"] = "payer";
    PersonType["COACH"] = "coach";
})(PersonType || (exports.PersonType = PersonType = {}));
